import React, { createContext, useContext } from 'react'

type BrightspotPageContext = {
  resolvedSite: string | null
  relativeUrl: string | null
  contentType: string | null
  previewId?: string
  status: string
}

type BrightspotPageProviderProps = {
  resolvedSite: string | null
  relativeUrl: string | null
  contentType: string | null
  previewId?: string
  status: string
  children: React.ReactNode
}

export const BrightspotPageContext = createContext({} as BrightspotPageContext)

export default function BrightspotPageProvider({
  resolvedSite,
  relativeUrl,
  contentType,
  status,
  previewId,
  children,
}: BrightspotPageProviderProps): JSX.Element {
  return (
    <BrightspotPageContext.Provider value={{ resolvedSite, relativeUrl, contentType, status, previewId }}>
      {children}
    </BrightspotPageContext.Provider>
  )
}

export function useBrightspotPage(): BrightspotPageContext {
  return useContext(BrightspotPageContext)
}
